const OpenApiServerEnvironmentMapping = {
  test: 'food-open.test.',
  uat: 'food-open.uat.',
  staging: 'food-open.staging.',
  live: 'food-open.',
}

const EnvironmentMapping = {
  test: 'test.',
  uat: 'uat.',
  staging: 'staging.',
  live: '',
}

const ServerEnvironmentMappingVn = {
  test: 'merchant-api.test.shopeefood.vn',
  uat: 'merchant-api.uat.shopeefood.vn',
  staging: 'gmerchant.stage.now.vn',
  live: 'gmerchant.deliverynow.vn',
}

const ServerCountryMapping = {
  my: 'shopee.com.my',
  th: 'shopee.co.th',
  vn: 'shopee.vn',
  id: 'shopee.co.id',
}

function getFoodyServerGolangBaseUrl(env, cid) {
  return `https://foody.${EnvironmentMapping[env]}${ServerCountryMapping[cid]}`
}

function getFoodyServerPythonBaseUrl(env) {
  return `https://${ServerEnvironmentMappingVn[env]}`
}

function getFoodyServerBaseUrl(env, cid) {
  if (cid === 'vn') {
    return `https://${ServerEnvironmentMappingVn[env]}`
  }

  return `https://foody.${EnvironmentMapping[env]}${ServerCountryMapping[cid]}`
}

function getOpenApiServerBaseUrl(env, cid) {
  return `https://${OpenApiServerEnvironmentMapping[env]}${ServerCountryMapping[cid]}`
}

module.exports = {
  getFoodyServerGolangBaseUrl,
  getFoodyServerPythonBaseUrl,
  getFoodyServerBaseUrl,
  getOpenApiServerBaseUrl,
}
